














import {Component, Vue} from 'vue-property-decorator';
import Table from '@c/tables/Table.vue';
import EditDialog from './RoleEditDialog.vue';
import {RoleTableHeader} from './interfaces';
import roleStoreModule from '@/store/modules/entities/roleModule';
import {Can} from '@casl/vue';

@Component({
  components: {
    Table,
    EditDialog,
    Can,
  },
})
export default class AdministrationRoles extends Vue {
  get apiStore() {
    return roleStoreModule;
  }

  private editDialog = EditDialog;

  headers: RoleTableHeader[] = [
    {
      text: 'Роль',
      value: 'name',
      sortable: false,
    },
  ];
}
